import EcommerceTest from '@/components/ecommerce/EcommTest.vue'

const ecommRoutes = [
  {
    path: '/ecommerce/test',
    name: 'ecommerce-test',
    component: EcommerceTest,
  }
]

export default ecommRoutes
